import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./styles.css";

const root = document.getElementById("root");

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
    sendDefaultPii: false,
  });
}

if (!root) {
  throw new Error("Root element was not found");
}

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="fatal-error"><h1>The workspace hit an error.</h1><p>Refresh the page to continue.</p></div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
